import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
@Directive({
  selector: '[startNationalIdOne]'
})
export class StartNationalIdOneDirective {

  constructor(private ngControl: NgControl, private el: ElementRef) { }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const currentValue: string = this.ngControl.value || '';
    const keyPressed: string = event.key;

    // Allow backspace and delete for editing purposes
    if (keyPressed === 'Backspace' || keyPressed === 'Delete') {
      return;
    }

    // Prevent entry of digits other than '1' at the start
    if (currentValue === '' && keyPressed !== '1') {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (value.startsWith('1')) {
      // Maintain the value as long as it starts with '1'
      if (this.el.nativeElement.selectionStart === 1) {
        this.ngControl.control?.setValue(value);
      }
    } else if (value.length > 0) {
      // If it doesn't start with '1', reset to '1'
      this.ngControl.control?.setValue('1' + value.replace(/^[^\d]/, ''));
    }
  }
}
